import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PdfDownloadService {

  baseurl = environment.baseUrl;
  constructor(private http: HttpClient) { }
  get(endpoint: string, params?: any, options?: any): Observable<any> {
    let url = `${this.baseurl}${endpoint}`;

    if (params !== undefined) {
      url += params;
    }

    return this.http.get(url, options).pipe(
      catchError((error: any) => throwError(() => error))
    );
  }

  // get(endpoint: string, params?: any): Observable<any> {
  //   if (params == undefined) {
  //     var url = `${this.baseurl}${endpoint}`;
  //   }
  //   else {
  //     var url = `${this.baseurl}${endpoint}${params}`;
  //   }
  //   return this.http.get(url).pipe(
  //     catchError((error: any) => {
  //       return throwError(() => error);
  //     })
  //   );
  // }
}
